/* src/app/system-poster/system-poster.component.css */
.system-poster {
  border-color: black;
  border-width: 35px 22px 35px 22px;
  border-style: solid;
  margin: 20px;
  width: 700px;
  height: 1000px;
  position: relative;
}
.inner-border {
  border-color: #f78c0a;
  border-width: 15px 20px 15px 20px;
  border-style: solid;
  width: 100%;
  height: 100%;
  position: relative;
}
.corner-number {
  position: absolute;
  top: -14px;
  right: -19px;
  background: #f78c0a;
  color: #222;
  width: 180px;
  height: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 4rem;
  z-index: 2;
}
.poster-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.qr-code {
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.qr-code img {
  display: block;
  margin: 0 auto;
  margin-top: 40px;
  max-width: 100%;
  height: auto;
}
.poster-text {
  margin-top: 32px;
  font-size: 1.2rem;
  color: #333;
  text-align: left;
  max-width: 90%;
  word-break: break-word;
  line-height: 1.2em;
  font-weight: 600;
}
.poster-text hr {
  border: none;
  border-top: 2px solid #f78c0a;
  margin: 32px auto 24px auto;
  width: 80%;
  display: block;
}
.flag-row {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 4px;
}
.flag-icon {
  width: 38px;
  height: 28px;
  object-fit: cover;
  margin: 10px;
  margin-top: 5px;
  margin-bottom: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  border-radius: 3px;
  display: inline-block;
}
ol.styled-numbers {
  counter-reset: item;
  padding-left: 0;
}
ol.styled-numbers li {
  list-style: none;
  counter-increment: item;
  margin-bottom: 0.7em;
  position: relative;
  padding-left: 2em;
  font-size: 1.15em;
}
ol.styled-numbers li::before {
  content: counter(item) ".";
  position: absolute;
  left: 0;
  color: #f78c0a;
  font-weight: bold;
  font-size: 1.15em;
}
.water-mark {
  position: absolute;
  bottom: 24px;
  right: 24px;
  width: 190px;
  height: auto;
  pointer-events: none;
  z-index: 1;
}
@media print {
  .corner-number {
    background: #f78c0a !important;
    color: #222 !important;
    border-color: #f78c0a !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
  .inner-border {
    border-color: #f78c0a !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
  .system-poster {
    border-color: black !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
  .flag-icon {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
}
/*# sourceMappingURL=system-poster.component.css.map */
